// Libs
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

class PermissionRequire extends Component {
  hasPermission() {
    const { user, allowedRoles } = this.props;
    
    // Se não passar allowedRoles, permite acesso
    if (!allowedRoles || allowedRoles.length === 0) {
      return true;
    }
    
    // Verifica se o role do usuário está na lista de roles permitidos
    return allowedRoles.includes(user.role);
  }

  getRedirectPath() {
    const { user } = this.props;
    
    // Redireciona baseado no role do usuário
    if (user.role === 'lawyer') {
      return '/meus-casos';
    } else if (user.role === 'company') {
      return '/dashboard';
    }
    
    return '/';
  }

  render() {
    const { children, isCheckingAuth, ...props } = this.props;

    if(isCheckingAuth) {
      return (
        <div>Carregando... {alert("Verificando permissões...")}</div>
      )
    }
    
    if (!this.hasPermission()) {
      return <Redirect to={this.getRedirectPath()} />;
    }
    
    const ComposedComponent = React.cloneElement(children, { ...props });
    return ComposedComponent;
  }
}

PermissionRequire = connect(state => {
  return {
    user: state.auth.user,
    isCheckingAuth: state.isCheckingAuth
  };
}, {})(PermissionRequire);

export default PermissionRequire;